"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASOCIACION_TARIFAS_SMS_NG = exports.TIPO_SERVICIO_TARIFAS_SMS_NG = void 0;
exports.TIPO_SERVICIO_TARIFAS_SMS_NG = {
    API: 1,
    WEB: 2,
    AMBAS: 3,
};
exports.ASOCIACION_TARIFAS_SMS_NG = {
    NO_TIENE: 0,
    TIENE: 1,
};
